export default __webpack_public_path__ + "static/media/icon-redirect-4.4dead0a6.svg";